// extracted by mini-css-extract-plugin
export var author = "mobileMenuItem-module--author--dd9ec";
export var category = "mobileMenuItem-module--category--42c42";
export var headline = "mobileMenuItem-module--headline--0b019";
export var headlinePost = "mobileMenuItem-module--headline-post--276c6";
export var industryIcon = "mobileMenuItem-module--industry-icon--2b820";
export var menuItem = "mobileMenuItem-module--menu-item--2a58f";
export var menuItemLabel = "mobileMenuItem-module--menu-item-label--f495c";
export var menuItemToggle = "mobileMenuItem-module--menu-item-toggle--4a58c";
export var menuItemToggleRotate = "mobileMenuItem-module--menu-item-toggle-rotate--bc178";
export var paragraph = "mobileMenuItem-module--paragraph--12545";
export var productIcon = "mobileMenuItem-module--product-icon--b69aa";
export var subItem = "mobileMenuItem-module--sub-item--02624";
export var subMenuItemsList = "mobileMenuItem-module--sub-menu-items-list--3fb67";